import { getConditionalArray } from 'utils/data';

import {
  AppraisalOrderContactSource,
  OrderContactActionText,
} from '../../AppraisalOrderContactsCard.constants';
import { AppraisalOrderContactsCardTestIds } from '../../AppraisalOrderContactsCard.testIds';

export const getOrderContactActionItems = ({
  rowKey,
  contact,
  source,
  isPrimary,
  isLocked,
  isOtherKind,
  icons,
  handlers,
}) => [
  {
    text: OrderContactActionText.SET_AS_PRIMARY,
    icon: icons.setAsPrimary,
    isDisabled: !contact || isPrimary,
    onClick: handlers.onSetPrimary,
    'data-testid': AppraisalOrderContactsCardTestIds.getSetPrimaryButtonId(rowKey),
  },
  ...getConditionalArray(!!contact?.isManual, () => [
    {
      text: OrderContactActionText.EDIT,
      icon: icons.edit,
      onClick: handlers.onEdit,
      'data-testid': AppraisalOrderContactsCardTestIds.getEditButtonId(rowKey),
    },
  ]),
  ...getConditionalArray(!!contact?.isAgent, () => [
    {
      text: OrderContactActionText.OPEN_AGENT_AND_SELLER,
      icon: icons.openAgentAndSeller,
      onClick: handlers.onOpenAgentAndSeller,
      'data-testid': AppraisalOrderContactsCardTestIds.getOpenAgentAndSellerButtonId(rowKey),
    },
  ]),
  ...getConditionalArray(!isLocked && !isOtherKind, () => [
    {
      text: OrderContactActionText.DONT_SEND,
      icon: icons.remove,
      isDisabled: source === AppraisalOrderContactSource.NONE,
      onClick: handlers.onClear,
      'data-testid': AppraisalOrderContactsCardTestIds.getDontSendButtonId(rowKey),
    },
  ]),
  ...getConditionalArray(isOtherKind, () => [
    {
      text: OrderContactActionText.REMOVE,
      icon: icons.remove,
      onClick: handlers.onRemove,
      'data-testid': AppraisalOrderContactsCardTestIds.getRemoveButtonId(rowKey),
    },
  ]),
];
